// ══════════════════════════════════════════════════════════════
// COMPASS – Board Member State Model (US-041)
// ══════════════════════════════════════════════════════════════

import { ManagementCompanyBoardMemberDto } from '../../api/models/management-company-board-member-dto';

export interface BoardMemberState {
  /** Every Board Member of the selected management company, active and inactive. */
  boardMembers: ManagementCompanyBoardMemberDto[];
  loading: boolean;
  saving: boolean;
  /** A deactivate or reactivate in flight. */
  updating: boolean;
  error: string | null;
}

export const initialBoardMemberState: BoardMemberState = {
  boardMembers: [],
  loading: false,
  saving: false,
  updating: false,
  error: null,
};
